/**
 * @param marketoForm {MarketoForm}
 * @param formData {Object}
 * @return {void}
 */
module.exports = function copyFormDataIntoMarketoForm(marketoForm, formData) {
    marketoForm.vals(formData);
    marketoForm.addHiddenFields(formData);
}